/** Read the __Secure-csrf cookie value, or null if absent. */
export function getCsrfToken(): string | null {
  const match = document.cookie.match(
    /(?:^|;\s*)__Secure-csrf=([^;]*)/,
  );
  return match ? decodeURIComponent(match[1]) : null;
}
